import { Provider } from 'react-redux';
import store from 'src/config/store';

import { ToastContainer } from '@southfields-digital/mxmz-react-ui';
import { Router } from 'src/Router';

import ErrorBoundary from 'src/components/ErrorBoundary/ErrorBoundary';
import InternalServerError from 'src/pages/InternalServerError/InternalServerError';

import 'react-toastify/dist/ReactToastify.css';
import './App.scss';

function App() {
  return (
    <ErrorBoundary FallbackComponent={InternalServerError}>
      <Provider store={store}>
        <Router />
        <ToastContainer autoClose={3000} position="bottom-right" hideProgressBar newestOnTop />
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
